import * as canvas from './canvas';
import * as svg from './svg';

export { canvas, svg };
